import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import TextCaseConverter from '../../components/TextCaseConverter';

const TextCaseConvert: React.FC = () => (
  <ToolLayout
    title="Text Case Converter - camelCase, snake_case | AllTools"
    description="Convert text between camelCase, PascalCase, snake_case, kebab-case, and more. Free text case converter."
    canonicalPath="/text-case-converter"
  >
    <TextCaseConverter />
  </ToolLayout>
);

export default TextCaseConvert;
